import {
    getServicesAllListRequest,
    getServicesAllRequest,
} from '../../../../../services/network/region_services/services/all';

class CommonServicesAllService {
    async getServicesAllList(payload) {
        return await getServicesAllListRequest(payload);
    }

    async getServicesAll(id) {
        return await getServicesAllRequest(id);
    }
}

export const ServicesAllService = new CommonServicesAllService();
